/*!
 * Bloom Multimedia ©
 * https://www.bloom-multimedia.fr/
 *
 * Date: 2022-01-24
 */

import Vue from "vue";
import Cookies from "./Cookies.vue";

window.addEventListener("load", () => {
  if (!document.getElementById("wrapper-cookies")) {
    const body = document.body,
      elt = document.createElement("div");
    elt.id = "wrapper-cookie";
    body.appendChild(elt);
    body.classList.add("bloom-cookies");
    new Vue({
      render: (h) => h(Cookies),
    }).$mount("#wrapper-cookie");
  }
});